var map = {
	"./bronze.png": "223a",
	"./diamante.png": "50dc",
	"./duplo-diamante.png": "0a53",
	"./embaixador-global.png": "6b58",
	"./embaixador.png": "7ac6",
	"./esmeralda.png": "2321",
	"./imperial.png": "df35",
	"./ouro.png": "f664",
	"./prata.png": "a3ea",
	"./safira.png": "8da2",
	"./triplo-diamante.png": "98cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ee0";